import React from "react";
import { Priceable, PaymentType } from "../../Types";
import { Quotation } from "../../../../stores/CoursePreviewStore/Types";
import Community from "./Subscriptions/Community";
import Lifetime from "./Subscriptions/Lifetime";
import Monthly from "./Subscriptions/Monthly";
import ThoughtLeadersPhoto from "./ThoughtLeadersPhoto";
import MonthlyFlexEd from "./Subscriptions/MonthlyFlexEd";
import Yearly from "./Subscriptions/Yearly";

interface Props {
  slug: string;
  path: string;
  priceable: Priceable;
  activeQuote: Quotation;
  paymentType: PaymentType;
  couponCode: string;
  refCode: string;
  amount: string;
  discountAmount: string;
  monthlySubsequentPayment: string;
  handleShowCouponModal: (e: any, val: boolean) => void;
  refreshQuoteWithoutCoupon: (e: any) => void;
}

const Subscription: React.FC<Props> = ({
  slug,
  path,
  priceable,
  activeQuote,
  couponCode,
  refCode,
  amount,
  paymentType,
  discountAmount,
  monthlySubsequentPayment,
  handleShowCouponModal,
  refreshQuoteWithoutCoupon,
}) => {
  const isCommunity = slug === "community" || priceable?.is_community;
  const isLifetime = slug === "lifetime" || priceable?.is_lifetime;

  if (isLifetime) {
    return (
      <Lifetime
        activeQuote={activeQuote}
        couponCode={couponCode}
        refCode={refCode}
        refreshQuoteWithoutCoupon={refreshQuoteWithoutCoupon}
        forMember={Boolean(priceable?.discounted)}
      />
    );
  }

  return (
    <>
      <h3>Your plan</h3>
      {!isCommunity && <ThoughtLeadersPhoto />}
      <div className="plan-header">
        {isCommunity ? (
          <>
            <div className="plan-icon" id="planIcon" aria-hidden="true">
              <span style={{ fontSize: "28px" }}>💬</span>
            </div>
            <div className="plan-details">
              <h4 id="planTitle">Community Hub</h4>
              <p id="planSubtitle">Monthly membership</p>
            </div>
          </>
        ) : (
          <>
            <div className="plan-details">
              <h4 id="planTitle">Yearly All Courses Pass</h4>
              <p id="planSubtitle">Unlimited access to every course</p>
            </div>
          </>
        )}
      </div>
      {slug === "month-flex-ed" && <MonthlyFlexEd activeQuote={activeQuote} />}
      {isCommunity && (
        <Community
          activeQuote={activeQuote}
          couponCode={couponCode}
          refCode={refCode}
          refreshQuoteWithoutCoupon={refreshQuoteWithoutCoupon}
        />
      )}
      {priceable?.interval === "month" &&
        !priceable?.is_restricted &&
        !priceable?.is_community && (
          <Monthly
            priceable={priceable}
            activeQuote={activeQuote}
            couponCode={couponCode}
            refCode={refCode}
            amount={amount}
            discountAmount={discountAmount}
            monthlySubsequentPayment={monthlySubsequentPayment}
            refreshQuoteWithoutCoupon={refreshQuoteWithoutCoupon}
          />
        )}
      {priceable?.interval === "year" && (
        <Yearly
          activeQuote={activeQuote}
          couponCode={couponCode}
          refCode={refCode}
          refreshQuoteWithoutCoupon={refreshQuoteWithoutCoupon}
        />
      )}
    </>
  );
};

export default Subscription;
